import React from 'react';
import { Box, TextField, Typography } from '@mui/material';
import MarkdownRenderer from '@components/MarkdownRenderer';

const MarkdownEditor = ({
  postText,
  setPostText
}: {
  postText: string;
  setPostText: (value: string) => void;
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPostText(e.target.value);
  };

  return (
    <Box mt={2}>
      {/* Markdown Editor */}
      <TextField
        label="Post Content"
        fullWidth
        variant="outlined"
        value={postText}
        onChange={handleChange}
        multiline
        minRows={10}
      />

      {/* Markdown Preview */}
      <Box mt={4}>
        <Typography variant="h6" gutterBottom>
          Preview
        </Typography>
        <Box
          sx={{
            border: '1px solid #ccc',
            borderRadius: '4px',
            padding: '16px',
            backgroundColor: '#f9f9f9'
          }}
        >
          <MarkdownRenderer content={postText} />
        </Box>
      </Box>
    </Box>
  );
};

export default MarkdownEditor;
